module.exports = __webpack_public_path__ + "img/Recurso 17@300xe.73410dd9.webp";